module.exports = __webpack_public_path__ + "71e200c237b4d36710306300f9a8d51f.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/above-the-fold-new-bg2.png
// module id = ./app/images/above-the-fold-new-bg2.png
// module chunks = 40